import styled from 'styled-components';
import { Popup } from '~/components/ui/Popup';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $open: boolean }>`
	position: relative;
	width: 340px;
	padding: 20px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	height: ${({ $open }) => ($open ? '255px' : '62px')};
	overflow: hidden;
	transition:
		height 0.3s ease,
		background-color 0.3s ease;

	${({ $open }) =>
		!$open &&
		`
		cursor: pointer;

        &:hover {
            background-color: #ffffff;

            ${StyledHead} {
             ${Text} {
                color: #000000;
            }
               img {
                filter: invert(100%);}
            }
        }
	`}
`;

const StyledHead = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr auto;
	gap: 10px;
	align-items: center;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

const StyledInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledInfoItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	${Text} {
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledBalanceContainer = styled.div`
	display: flex;
	gap: 6px;
	align-items: center;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledPopup = styled(Popup)`
	position: absolute;
	bottom: 70px;
	left: 50%;
	transform: translateX(-50%);
`;

export {
	StyledBalanceContainer,
	StyledContainer,
	StyledHead,
	StyledInfo,
	StyledInfoItem,
	StyledPopup,
};
